const UTMIFY_UTMS_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const UTMIFY_PIXEL_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'

/**
 * Loads the official UTMify tracking scripts.
 * Safe to call multiple times — scripts are injected only once.
 */
export function loadUtmify(pixelId?: string): void {
  if (typeof document === 'undefined') return

  if (!document.querySelector(`script[src="${UTMIFY_UTMS_SRC}"]`)) {
    const utmsScript = document.createElement('script')
    utmsScript.src = UTMIFY_UTMS_SRC
    utmsScript.async = true
    utmsScript.defer = true
    utmsScript.setAttribute('data-utmify-prevent-xcod-sck', '')
    utmsScript.setAttribute('data-utmify-prevent-subid', '')
    document.head.appendChild(utmsScript)
  }

  if (pixelId && !document.querySelector(`script[src="${UTMIFY_PIXEL_SRC}"]`)) {
    const w = window as unknown as { pixelId?: string }
    w.pixelId = pixelId

    const pixelScript = document.createElement('script')
    pixelScript.src = UTMIFY_PIXEL_SRC
    pixelScript.async = true
    pixelScript.defer = true
    document.head.appendChild(pixelScript)
  }
}
